import gql from "graphql-tag";

export const offsiteBookingGuestCardsQuery = gql`
  query offsiteBookingGuestCards($installationId: ID!) {
    allRateCards(
      filter: {
        installationId: $installationId
        isArchived: false
      }
      orderBy: name_ASC
    ) {
      id
      lineageId
      version
      name
      type
      calculationMode
      entryAfterTime
      exitBeforeTime
      bookingRateAudPerDay
      bookingRateAudPerMonth
      weekendSurchargeRate
      overstayRateAudPerHour
      overstayFlagfallAud
      overstayGraceMinutes
      guestName
      guestEmail
      guestPhone
      guestCompany
      guestDepartment
      guestRoom
      guestApartmentNumber
      guestReservation
      guestEmployeeCode
      guestPosition
      paymentStripe
      valetPayLater
      isValet
      valetRequestFeeAud
      includeCarType
      includeCarNotes
      isArchived
      allowFutureDate
      activeDaysOfWeek
      activeFromMinute
      activeToMinute
      fixedBookingStartDate
      fixedBookingEndDate
      packagePriceAud
      lot {
        id
        name
      }
    }
  }
`;

export const offsiteTicketLotDashboardQuery = gql`
  query offsiteTicketLotDashboard {
    offsiteTicketLotDashboard {
      summary {
        ticketsLeft
        preBooked
        allocated
        flags
      }
      lots {
        lot {
          id
          name
          description
          type
          capacity
          enableCapacityLimit
          address
          walkingDistanceMinutes
        }
        capacity
        occupied
        allocatedTickets
        redeemedTickets
        flaggedTickets
        available
        occupancyPercent
        bookings {
          id
          rateCardId
          plate
          guestName
          guestEmail
          guestPhone
          stripeCustomerId
          startDay
          endDay
          status
          rateCard {
            id
            name
            version
            paymentStripe
            isValet
            valetRequestFeeAud
            lot {
              id
              name
              type
            }
          }
          paymentState {
            isPaid
            isPendingCharge
            amountAud
            paidAt
            lastChargeStatus
          }
          offsiteTickets {
            id
            ticketCode
            status
            licensePlate
            guestName
            guestEmail
            checkInAt
            checkOutAt
            issuedAt
            issuedById
            issuedBy {
              id
              name
              email
            }
            redeemedAt
            flaggedAt
            flagReason
          }
        }
      }
    }
  }
`;

export const createOffsiteTicketMutation = gql`
  mutation createOffsiteTicket($input: CreateOffsiteTicketInput!) {
    createOffsiteTicket(input: $input) {
      id
      ticketCode
      status
      licensePlate
      guestName
      guestEmail
      guestPhone
      checkInAt
      checkOutAt
      issuedAt
      issuedById
      issuedBy {
        id
        name
        email
      }
      redeemedAt
      flaggedAt
      flagReason
    }
  }
`;

export const updateOffsiteTicketMutation = gql`
  mutation updateOffsiteTicket($input: UpdateOffsiteTicketInput!) {
    updateOffsiteTicket(input: $input) {
      id
      ticketCode
      status
      licensePlate
      guestName
      guestEmail
      guestPhone
      checkInAt
      checkOutAt
      issuedAt
      issuedById
      issuedBy {
        id
        name
        email
      }
      redeemedAt
      flaggedAt
      flagReason
    }
  }
`;
